import { Close } from "@mui/icons-material";
import { Dialog, DialogProps, Stack } from "@mui/material";
import Button from "components/button";
import { BUTTON_SIZE } from "components/button/interface";

import SuccessTick from "../../assets/icons/SuccessTick.svg";
import WarningTick from "../../assets/icons/WarningTick.svg";
import { ConfirmationDialogProps } from "./interface";
import {
  ButtonWrapper,
  DialogCloseButton,
  DialogContentWrapper,
  HeadingText,
  MessageText,
} from "./styled.components";

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    show,
    dismiss,
    buttonText,
    msg,
    heading,
    onButtonClickHandler,
    type,
    hideCloseIcon = false,
    hideIcon = false,
    headingAlign = "center",
    messageAlign,
  } = props;

  const handleClose: DialogProps["onClose"] = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    dismiss();
  };

  const icon = type === 0 ? SuccessTick : WarningTick;
  return (
    <Dialog maxWidth="sm" open={show} onClose={handleClose}>
      <DialogContentWrapper>
        {!hideCloseIcon && (
          <DialogCloseButton onClick={dismiss}>
            <Close />
          </DialogCloseButton>
        )}
        <Stack direction="column" width="100%">
          {heading && (
            <HeadingText sx={{ textAlign: headingAlign, width: "100%" }}>
              {heading}
            </HeadingText>
          )}
          <Stack direction="row" gap="16px" alignItems="flex-start">
            {!hideIcon && (
              <img src={icon} alt="success" style={{ paddingTop: "4px" }} />
            )}
            <MessageText
              sx={{ textAlign: messageAlign || (hideIcon ? "center" : "left") }}
            >
              {msg}
            </MessageText>
          </Stack>
        </Stack>
        <ButtonWrapper>
          <Button
            onClickHandler={onButtonClickHandler}
            size={BUTTON_SIZE.MEDIUM}
          >
            {buttonText}
          </Button>
        </ButtonWrapper>
      </DialogContentWrapper>
    </Dialog>
  );
};

export default ConfirmationDialog;
